import {defineNuxtPlugin} from '#app';
import {createSignalRConnection} from '~/services/signalRService';

export default defineNuxtPlugin(async () => {
  // Function to initialize SignalR connection
  const initializeSignalR = async () => {
    try {
      await createSignalRConnection();
    } catch (err) {
      console.error('SignalR Connection Error: ', err);
    }
  };

  return {
    provide: {
      initializeSignalR
    }
  };
});